import { Alert, SimpleGrid, Stack } from '@mantine/core';
import { mapApiToAtlasData } from './helpers';
import { useDashboardSectionData } from '../hooks/useDashboardSectionData';
import { PerformanceCardSkeleton } from '../PerformanceCardSkeleton';
import { ApplicantsCard } from './cards/ApplicantsCard';
import { CompletionsCard } from './cards/CompletionsCard';
import { EmployerSatisfactionCard } from './cards/EmployerSatisfactionCard';
import { ParticipantsCard } from './cards/ParticipantsCard';

export function AtlasPerformanceMetrics() {
  const { mappedData: atlasData, error, isLoading } = useDashboardSectionData({
    queryKey: 'atlas',
    fallbackGroupId: 'Atlas',
    enabled: (group) => group === 'Atlas',
    mapData: mapApiToAtlasData,
  });

  return (
    <Stack spacing="lg">
      {error ? (
        <Alert color="yellow" variant="light">
          Unable to load dashboard API data.
        </Alert>
      ) : null}
      {!isLoading && !atlasData ? (
        <Alert color="yellow" variant="light">
          No dashboard API data returned for this section.
        </Alert>
      ) : null}
      {isLoading && !atlasData ? (
        <>
          <PerformanceCardSkeleton />
          <PerformanceCardSkeleton />
          <SimpleGrid cols={2} spacing="lg" breakpoints={[{ maxWidth: 980, cols: 1 }]}>
            <PerformanceCardSkeleton />
            <PerformanceCardSkeleton />
          </SimpleGrid>
        </>
      ) : null}
      {atlasData ? (
        <>
          <ParticipantsCard data={atlasData} />
          <CompletionsCard data={atlasData} />
          <SimpleGrid cols={2} spacing="lg" breakpoints={[{ maxWidth: 980, cols: 1 }]}>
            <ApplicantsCard data={atlasData} />
            <EmployerSatisfactionCard data={atlasData} />
          </SimpleGrid>
        </>
      ) : null}
    </Stack>
  );
}
